// MQTT plugin — exposes the mqtt client factory as Vue.$mqtt.
// Mirrors chekt-web-monitoring-v2 (src/plugins/mqtt.js). We import the prebuilt
// browser bundle (dist/mqtt.min.js) so it works under webpack 5 without node
// core polyfills (process/Buffer/stream), unlike the raw `import * as mqtt`.
import mqtt from 'mqtt/dist/mqtt.min.js'

const MqttPlugin = {
  install (Vue) {
    Vue.prototype.$mqtt = mqtt
    Vue.mqtt = mqtt
  },
}

export default MqttPlugin
